import { useUserCourses } from '../pages/meeting-view/hooks/useCourses'
import { useQuery } from '@tanstack/react-query'
import { fetchExpertMentors } from '../apis/api-assignation'
import { useSessionParams } from './useSessionParams'

export const queryKeyHRExpertMentors = ['Expert Mentors', 'Status']

export const useHRExpertMentors = () => {
    const { currentCourse } = useUserCourses()
    const { room } = useSessionParams()
    const myProfileId = currentCourse?.profileId
    const isExpertMentor = !!currentCourse?.isExpertMentor

    const { data, ...rest } = useQuery({
        queryKey: queryKeyHRExpertMentors,
        queryFn: fetchExpertMentors,
        enabled: !!isExpertMentor && room === 'teams',
        staleTime: 1000 * 60 * 3, // 3 minutes
    })

    const isAttendingHelpRequest = !!data?.mentors?.busy?.find(({ profileId }) => profileId === myProfileId)
    const showHRPanel = isExpertMentor && !isAttendingHelpRequest

    return { ...data, isExpertMentor, isAttendingHelpRequest, showHRPanel, ...rest }
}
